export const BLOCKFROST_API_KEY = "mainnetTReeSC5Ff5GPBdS2WMZ7BWN57K3MHZ9b"